import React, { useState } from 'react'

import DeleteConfirm from 'util/modules/Confirm/DeleteConfirm'
import { deleteStorageItems } from '../service/store.service'

export const DeleteStorageItems: React.FC<{ ids: string[] }> = ({ ids }) => {
  const [isOpen, setOpen] = useState(false)
  const { mutate } = deleteStorageItems()

  return (
    <>
      <button
        disabled={ids.length === 0}
        onClick={() => setOpen(true)}
        className="button radius remove margin-right-8"
        style={{
          color: 'firebrick',
          width: 250,
          opacity: ids.length ? 1 : 0.4,
          borderColor: 'firebrick'
        }}
      >
        <i className="fa fa-trash" style={{ color: 'firebrick' }} /> Deletar &quot;{ids.length}&quot; item(s)
      </button>
      <DeleteConfirm
        isOpen={isOpen}
        onCancel={() => setOpen(false)}
        onConfirm={() => mutate({ ids }, { onSuccess: () => setOpen(false) })}
      />
    </>
  )
}
